import { render, staticRenderFns } from "./page-numbers.vue?vue&type=template&id=af7ab810&scoped=true&"
import script from "./page-numbers.vue?vue&type=script&lang=js&"
export * from "./page-numbers.vue?vue&type=script&lang=js&"
import style0 from "./page-numbers.vue?vue&type=style&index=0&id=af7ab810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af7ab810",
  null
  
)

export default component.exports